module.exports = __webpack_public_path__ + "img/icon-grafik.a39f1de0.png";